import { css } from "@emotion/react"
import React, { useEffect, useState } from "react"
import Fade from "react-reveal/Fade"
import CarouselComponent from "../carousel-component"
import "./ColorCards.scss"

const ColorCards = props => {
  const { title, description, image, color } = props
  const responsive = {
    desktop: {
      breakpoint: { max: 3000, min: 1024 },
      items: 2.19,
    },
    tablet: {
      breakpoint: { max: 1024, min: 767 },
      items: 1.2,
    },
    mobile: {
      breakpoint: { max: 767, min: 500 },
      items: 1.2,
    },
    mobile1: {
      breakpoint: { max: 500, min: 0 },
      items: 1,
    },
  }
  const [screenWidth, setScreenWidth] = useState(0)
  useEffect(() => {
    setScreenWidth(window.innerWidth)
  }, [])
  let delayCount = 0

  return (
    <div className="color-cards ">
      <div className="d-mob">
        <CarouselComponent
          swipeable
          responsive={responsive}
          customButtonNew
          status
          items={screenWidth >= 992 ? 2.19 : 1}
          paginationDecrement={screenWidth >= 992 ? true : false}
          arrowClassName="btn-secondary-new"
        >
          {title?.map((item, idx) => {
            return (
              <div
                className="card-cover"
                css={css`
                  background: ${color?.[idx]};
                `}
              >
                <h3 className="font-zodiak fw-800 mx-auto heading mb16">
                  {item}
                </h3>
                <p className="p18 description mx-auto fw-500">
                  {description?.[idx]}
                </p>
                <div>
                  <img src={image?.[idx]?.url} className="w-100" />
                </div>
              </div>
            )
          })}
        </CarouselComponent>
      </div>

      <div className="d-dsk d-flex flex-wrap gap-24 justify-content-center">
        {title?.map((item, idx) => {
          if (delayCount > 5) {
            delayCount = 0
          }
          return (
            <Fade
              bottom
              delay={(delayCount + 1) * 130}
              duration="800"
              distance={"20px"}
            >
              <span className="dspnone">{delayCount++}</span>
              <div
                className="card-cover"
                css={css`
                  background: ${color?.[idx]};
                `}
              >
                <h3 className="font-zodiak fw-800 mx-auto heading mb16">
                  {item}
                </h3>
                <p className="p18 description mx-auto fw-500">
                  {description?.[idx]}
                </p>
                <div>
                  <img src={image?.[idx]?.url} className="w-100" />
                </div>
              </div>
            </Fade>
          )
        })}
      </div>
    </div>
  )
}

export default ColorCards
